<template>
<div>
    <div class="cart__total-products">{{ count }} {{ tovarov }} на сумму</div>
    <div class="cart__total-sum">{{ summ }} <span class="rub">i</span></div>
</div>
</template>

<script>
import {helpers} from "../helpers";

export default {
    name: "cart-summ",
    mixins: [helpers],
    computed: {
        count() {
            return this.$store.getters.cartcount;
        },
        summ() {
            return this.$store.getters.cartsumm;
        },
        tovarov() {
            return this.getNoun(this.$store.getters.cartcount, 'товар', 'товара', 'товаров')
        }
    }
}
</script>

<style scoped>

</style>
